import appConfig from '$app/internal/main';
import render from '$app/render/client';

/**
 * Client entry point to create the client bundle
 */

// onclick = () => {
//   render(appConfig.createApp, import.meta.env.APP_NAME);
// };

async function retryHydration(selector: string, maxAttempts = 10, delay = 200) {
  let attempts = 0;

  while (
    document.querySelectorAll(selector).length === 0 &&
    attempts < maxAttempts
  ) {
    attempts++;
    await new Promise((resolve) => setTimeout(resolve, delay));
  }

  if (document.querySelectorAll(selector).length > 0) {
    render(appConfig.createApp, import.meta.env.APP_NAME);
  } else {
    console.error('selector not found, cannot hydrate');
  }
}

retryHydration('[data-component-name="owvans-technical-data"]', 10, 500);
